export default __webpack_public_path__ + "static/media/icon_destination.2542bc16.svg";